import { z } from 'zod';

import { accessValidationShape } from '../../ClearVerifyStaffAccessFormPart/validation';
import { InviteFormFields, type InviteFormValues } from '../types';

const emailSchema = z.email();

export const inviteFormValidationSchema = z.object({
  [InviteFormFields.emails]: z
    .array(z.string())
    .min(1, 'Field must have at least 1 item')
    .superRefine((emails, ctx) => {
      const invalidEmails = emails.filter(email => !emailSchema.safeParse(email).success);

      if (invalidEmails.length > 0) {
        ctx.addIssue({
          code: 'custom',
          message: `Some emails are invalid: ${invalidEmails.join(', ')}`,
        });
      }
    }),
  ...accessValidationShape,
}) satisfies z.ZodType<InviteFormValues>;
